import React, { useState, useEffect } from 'react';
import { RemindersForm } from './components/RemindersForm';
import useCognitoAuth from './authorization/cognitoAuthorizer';
import { getPreferences } from './services/api';
import '@amzn/awsui-global-styles/polaris.css';
import { SpaceBetween, Box, StatusIndicator } from '@amzn/awsui-components-core';

function App() {
  const { isAuthenticated, userAlias, authToken } = useCognitoAuth();
  const [isLoadingPreferences, setIsLoadingPreferences] = useState(true);
  const [preferences, setPreferences] = useState<any>(null);

  useEffect(() => {
    const loadPreferences = async () => {
      if (isAuthenticated && authToken) {
        try {
          const prefs = await getPreferences(authToken);
          setPreferences(prefs);
        } catch (error) {
          console.error('Failed to load preferences:', error);
        } finally {
          setIsLoadingPreferences(false);
        }
      }
    };
    loadPreferences();
  }, [isAuthenticated, authToken]);

  if (!isAuthenticated || isLoadingPreferences) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <SpaceBetween alignItems="center" direction="vertical" size="m">
          <Box textAlign="center">
            <StatusIndicator type="loading">Authorizing user access</StatusIndicator>
          </Box>
          <Box color="text-body-secondary" padding={{horizontal: 'm'}} textAlign="center" variant="p">
            Please wait while we verify your credentials and load your personalized dashboard.
          </Box>
        </SpaceBetween>
      </div>
    );
  }

  return <RemindersForm userAlias={userAlias} initialPreferences={preferences} />;
}

export default App;